import React from "react";

export const FormattedText = ({ text, query }) => {
  const index = text ? text.toLowerCase().indexOf(query.toLowerCase()) : -1;
  if (index === -1) {
    return text;
  } else {
    const start = text.slice(0, index);
    const queryPlaceholder = text.slice(index, index + query.length);
    const end = text.slice(index + query.length);

    return (
      <>
        {start}
        <b>{queryPlaceholder}</b>
        {end}
      </>
    );
  }
};
